// extracted by mini-css-extract-plugin
export var anchor = "_5k-0";
export var discard = "_5k-4";
export var muiTooltipTooltip = "_5k-6";
export var notificationBar = "_5k-3";
export var saveButtonHoverSlotWrapper = "_5k-5";
export var show = "_5k-2";
export var spacer = "_5k-1";